export const REQUEST_BROWSER_NOTIFICATIONS = 'REQUEST_BROWSER_NOTIFICATIONS';
export const RECIEVE_BROWSER_NOTIFICATIONS = 'RECIEVE_BROWSER_NOTIFICATIONS';

// Browser Response Types for Notification Permissions
export const DEFAULT = 'default';
export const GRANTED = 'granted';
export const DENIED = 'denied';

// Strings
export const NOTIFICATION_REGISTRAR_COMMITTED = 'notifications_registrar_committed';
export const NOTIFICATION_DOMAIN_READY_REGISTER = 'notification_domain_ready_register';
export const NOTIFICATION_REGISTRAR_REVEALED = 'notifications_registrar_revealed';
